// import { useCallback } from "react";
import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { BarChartByProps } from '../config';
import { ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
// import { VILevel, VIType } from "@customer/store/apis/interactionsApi";
// import { CustomBarChartLabel, OnBarSelect } from "../bar-select/BarSelectPlugin";
// import { useAppDispatch, useAppSelector } from "@customer/store/hooks";
// import { saveFilters, setVehicleInteractionTypes } from "@customer/store/slices/filtersSlice";
// import { isEnumValue } from "@customer/shared/utils/typeHelpers";

// TODO: Re-enable the commented code after the UX for bar segment selection has been improved.

export const BarChartByAsset = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  // const dispatch = useAppDispatch();

  // const siteId = useAppSelector(state => state.auth.siteId);

  // const onBarSelect = useCallback<OnBarSelect>((category: CustomBarChartLabel, datasetId: string): void => {
  //   if (siteId && isEnumValue(datasetId, VILevel)) {
  //     // There is no 'Asset' filter, so filter by the VILevel.
  //     const typesMatchingLevel: VIType[] = Object.values(VIType).filter((type: VIType) => type.endsWith(datasetId));
  //     dispatch(setVehicleInteractionTypes(typesMatchingLevel));
  //     dispatch(saveFilters(siteId));
  //   }
  // }, [dispatch, siteId]);

  return (
    <BarChartScenario<T>
      {...props}
      // onBarSelect={onBarSelect}
    />
  );
};

export default BarChartByAsset;
